export enum ContactFormType {
  normal = 'normal',
  compact = 'compact',
  extended = 'extended',
  mini = 'mini'
}

export interface IWordpressContactForm {
  visible: boolean;
  order: number;
  type: ContactFormType;
  title: string;
  sub_title: string;
  button_text: string;
  metrika_event: string;
}
